export function Marquee({ items }) {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap font-mono text-xs uppercase tracking-[0.25em] text-foreground/70 sm:text-sm">
          <span className="px-6">{item}</span>
          <span className="text-primary">✳</span>
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-border bg-secondary/50 py-4"
    >
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
